import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import ItemList02Actions, { ItemList02Types } from '../Stores/ItemList02/Actions';

const getAppStore = state => state.app;

export function* itemList02FetchItemList02({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(ItemList02Actions.itemList02FetchItemList02Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `item/indexProcess/ITEM_LIST_02`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        ItemList02Actions.itemList02FetchItemList02Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ItemList02Actions.itemList02FetchItemList02Loading(false));
  }
}

export function* itemList02GoToResource({ resId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/itemDetail/update/${resId}/GENERAL`));
}

export function* itemList02GoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/ITEM/${hdrId}/Item`));
}

export function* itemList02NewResource() {
  const app = yield select(getAppStore);
  const itemType = 1000; // STOCK_ITEM
  yield put(push(`${app.appPath}/itemDetail/create/${itemType}/GENERAL`));
}

export const saga = [
  takeLatest(ItemList02Types.ITEM_LIST02_FETCH_ITEM_LIST02, itemList02FetchItemList02),
  takeLatest(ItemList02Types.ITEM_LIST02_GO_TO_AUDIT, itemList02GoToAudit),
  takeLatest(ItemList02Types.ITEM_LIST02_GO_TO_RESOURCE, itemList02GoToResource),
  takeLatest(ItemList02Types.ITEM_LIST02_NEW_RESOURCE, itemList02NewResource)
];
